export default __webpack_public_path__ + "static/media/loc.a9f79786.svg";